// Minimal client-side date-range filter for the real-estate visit dashboards (owner / admin /
// agent), mirroring jewelry's DeliveryList "Today / This week / ..." idea without the full
// collapsible filter panel. A visit's effective time is its scheduled agent slot if set, else its
// start date. Weeks start Monday; months are calendar months. `all` disables filtering.

export const VISIT_RANGE_OPTIONS = [
  { key: 'today', label: 'Today' },
  { key: 'this_week', label: 'This week' },
  { key: 'this_month', label: 'This month' },
  { key: 'all', label: 'All' }
];

function visitDate(visit) {
  return new Date(visit.deliveryAssignment?.scheduledAt || visit.startDate);
}

// [start, end) for the given range key, in the browser's local time; null => unbounded.
export function rangeBounds(range, now = new Date()) {
  const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const addDays = (d, n) => new Date(d.getTime() + n * 86400000);
  if (range === 'today') return [startOfDay, addDays(startOfDay, 1)];
  if (range === 'this_week') {
    const day = now.getDay();
    const diffToMonday = (day === 0 ? -6 : 1) - day;
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() + diffToMonday);
    return [start, addDays(start, 7)];
  }
  if (range === 'this_month') {
    return [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 1)];
  }
  return null; // 'all'
}

export function visitInRange(visit, range) {
  const bounds = rangeBounds(range);
  if (!bounds) return true;
  const t = visitDate(visit).getTime();
  return t >= bounds[0].getTime() && t < bounds[1].getTime();
}
